import { useState } from 'react';
import Iconify from 'src/components/Iconify';
import { TableMoreMenu } from 'src/components/table';
import { Box, MenuItem, TableCell, TableRow, Typography } from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { formatDateTimeToDefault } from 'src/utils/dates';
import { checkAclValidation } from 'src/careflow/ph-core/admin/permissions/util/permission.utils';
import crsAcls from 'src/careflow/ph-core/admin/permissions/util/crs/crsAcls';
import { capitalize } from 'lodash';
import { WrappedEpisodeOfCare } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/EpisodeOfCare';

type Props = {
  row: WrappedEpisodeOfCare | null;
  onData?: (episedeOfCare: WrappedEpisodeOfCare) => void;
  onDetailsClick?: (episodeOfCare: WrappedEpisodeOfCare) => void;
};

export function Row({ row, onData, onDetailsClick }: Props) {
  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  const handleEdit = () => {
    handleCloseMenu();
    if (row && onData) {
      onData(row);
    }
  };

  const handleDetails = () => {
    handleCloseMenu();
    if (row && onDetailsClick) {
      onDetailsClick(row);
    }
  };

  return (
    <>
      <TableRow
        onClick={handleDetails}
        sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'action.hover' } }}
      >
        <TableCell>{capitalize(row?.status)}</TableCell>
        <TableCell>
          <Box sx={{ maxWidth: 300 }}>
            <Typography style={{ cursor: 'pointer' }} noWrap sx={{ fontSize: `0.75rem` }}>
              {row?.type?.[0]?.coding?.[0]?.display}
            </Typography>
          </Box>
        </TableCell>
        <TableCell>{formatDateTimeToDefault(row?.period?.start)}</TableCell>
        <TableCell>{formatDateTimeToDefault(row?.period?.end)}</TableCell>
        <TableCell>{row?.careManager?.display}</TableCell>
        <TableCell align="right" onClick={(e) => e.stopPropagation()}>
          <TableMoreMenu
            open={openMenu}
            onOpen={handleOpenMenu}
            onClose={handleCloseMenu}
            actions={[
              ...(onData && checkAclValidation({ acls: [crsAcls.CRS.PATIENT.EPISODE_OF_CARE.EDIT] })
                ? [
                    <MenuItem
                      key={`edit-${row?.id}`}
                      onClick={handleEdit}
                      sx={{ '& svg': { mr: 0 } }}
                    >
                      <Iconify icon={'mdi:pencil'} />
                      Edit
                    </MenuItem>,
                  ]
                : []),
              <MenuItem
                key={`details-${row?.id}`}
                onClick={handleDetails}
                sx={{ '& svg': { mr: 0 } }}
              >
                <OpenInNewIcon sx={{ fontSize: 20, color: 'primary.main' }} />
                Details
              </MenuItem>,
            ]}
          />
        </TableCell>
      </TableRow>
    </>
  );
}
